
 
  function openclick(){
    document.querySelectorAll('.checkmain').forEach(function(ele) {
  ele.addEventListener("change", function(e) {
    e.preventDefault();

    const cartItem = ele.closest(".cart-item");
    const variantId = cartItem.getAttribute("data-variant-id");
    const sellingPlanId = cartItem.getAttribute("data-sellingplanm");
    const quantity = parseInt(cartItem.getAttribute("data-quantity")) || 1;
    const removeBtn = cartItem.querySelector(".cart-remove-button");

    if (!variantId || !removeBtn) {
      console.error("Missing variantId or remove button");
      return;
    }
    document.body.classList.add('loader_added'); 
    // ✅ Capture the checkbox state BEFORE removing
    if (ele.checked)
    var isChecked = true;
      else{
    var isChecked = false;
  }
    // ✅ Remove the current item via click
    removeBtn.click();

    // ⏱ Wait for the removal to process (Shopify delay)
    setTimeout(() => {
      const params = new URLSearchParams();
      params.append('id', variantId);
      params.append('quantity', quantity);

      // ☑️ Unchecked → add with selling plan
      if (isChecked == true && sellingPlanId && sellingPlanId !== "false") {
        params.append('selling_plan', sellingPlanId);
        console.log("Adding with selling plan:", sellingPlanId);
        document.body.classList.add('loader_added');
      } else {
        // 🔲 Checked → no selling plan
        console.log("Adding without selling plan");
      }

      // ✅ Add item back
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: params.toString()
      })
      .then(res => {
        if (!res.ok) {
          return res.text().then(text => {
            throw new Error(`Add to cart failed: ${text}`);
          });
        }
        
        return res.json();
      })
      .then(data => {
        console.log('Cart updated:', data);
         // 👉 Update cart drawer
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newDrawer = html.querySelector('#CartDrawer');

      if (newDrawer) {
        const existingDrawer = document.querySelector('#CartDrawer');
        existingDrawer.innerHTML = newDrawer.innerHTML;
        document.body.classList.add('overflow-hidden');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('loader_added');
        document.querySelector('cart-drawer').classList.add('animate', 'active');
        document.querySelector(".cradrawermainbox").classList.remove("is-empty");
        openclick();
      }
        var cartIconBubble = document.getElementById('cart-icon-bubble');

            fetch(window.location.href)
              .then(response => response.text())
              .then(data => {
                var tempElement = document.createElement('div');
                tempElement.innerHTML = data;
            
                var newCartIconBubble = tempElement.querySelector('#cart-icon-bubble');
            
                if (newCartIconBubble) {
                  cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
                }
              })
              .catch(error => {
                console.error('Error:', error);
              });
      document.body.classList.remove('loader_added');
    })
    .catch((error) => {
      console.error('Error updating cart drawer:', error);
      document.body.classList.remove('loader_added');

    });
      })
      .catch(error => {
        console.error('Error re-adding item:', error);
        document.body.classList.remove('loader_added');
      });

    }, 800); // Adjust delay as needed
  });
});
console.log("updated")
  }
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    var flag = $('.cart-timer [data-duration]').data('flag');
     if(flag == "1"){
         $('.cart-timer [data-duration]').data('flag', "0");
         setInterval(function() {
           var timer2 = $('.cart-timer [data-duration]').data('duration');
           var timer = parseInt(timer2);
           var minutes = parseInt(timer[0], 10);
           var seconds = parseInt(timer[1], 10);
           --timer;
           if(timer < 1){
            timer = 90;
           }
           $('.cart-timer [data-duration]').data('duration', timer);
           minutes = ~~(timer/60)
           seconds = ~~(timer%60)
           $('.cart-timer [data-duration]').html('<span>0'+minutes+'</span>:<span>'+(9<seconds?'':'0')+seconds+'</span>');
         }, 1000);
     }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
 
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

 //whenfuckeraddc

 setTimeout(function(){

openclick();
 
 }, 1000)
 //end








  const cartItems = this.querySelectorAll(".cart-item");
  let found = false;

  cartItems.forEach(function (item) {
    if (found) return; 

    const attrib = item.getAttribute("data-sellingplan");

    if (attrib) {
     const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

      upsellBtns.forEach(function (btn) {
        const upsellPlan = btn.getAttribute("data-sellingplan");

        const existingInput = btn.parentElement.querySelector(".sellingplancart");
        if (existingInput) existingInput.remove(); // Always clear first

        if (upsellPlan) {
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.className = "sellingplancart";
          hiddenInput.name = "selling_plan";
          hiddenInput.value = upsellPlan;

          btn.parentElement.insertBefore(hiddenInput, btn);
        }
      });
    var shipping_protection = document.querySelector("#privacy_protection_input");
 if (shipping_protection) {
  shipping_protection.setAttribute("data-selling", "12512690340");
 }
      found = true; 
    } else {

      
 const upsellBtns = document.querySelectorAll(".upsell-product-btn button");

      upsellBtns.forEach(function (btn) {
        const existingInput = btn.parentElement.querySelector(".sellingplancart");
        if (existingInput) existingInput.remove();
      });
      var shipping_protection = document.querySelector("#privacy_protection_input");
 if (shipping_protection) {
  shipping_protection.setAttribute("data-selling", "false");
 }
      console.log("No selling plan on this cart item — upsell selling plans removed.");

      
    }

    
  });
   

function updateConvertedAttributec(el) {
  
  // Get the base USD cents from attributes
  var usdCents = parseInt(el.getAttribute("data-pck"), 10);

  if (isNaN(usdCents)) return;

  // Convert cents → dollars first
var usdAmount = usdCents / 100;


  // Get active currency
  var activeCurrency = Shopify.currency.active || "USD";
  console.log(activeCurrency)
  var baseCurrency = Shopify.currency.default || "USD";

  // Get conversion rate
  
  var convertedAmount = (usdAmount * Shopify.currency.rate).toFixed(2);

  setTimeout(function(){


  el.setAttribute("data-pck", "$" + convertedAmount);
  el.textContent="$" + convertedAmount;
  console.log(el, "textcontentChanged")
    }, 4000)


  
}


document.querySelectorAll(".cart-item__old-price.product-option").forEach(updateConvertedAttributec);

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
